import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
Vue.prototype.$axios = axios;

export default new Vuex.Store({
  state: {
    name: null,
    avatar: null,
    nickname: null,
    data: null,
    loginStatus: false
  },
  mutations: {
    setLoginStatus(state, data) {
      state.loginStatus = data
    }
  },
  actions: {

  }
})
